"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _HeadMenu = _interopRequireDefault(require("./HeadMenu"));

var _search = _interopRequireDefault(require("../../assets/images/search.svg"));

var _cross = _interopRequireDefault(require("../../assets/images/cross.svg"));

var _ArrowLink = _interopRequireDefault(require("./ArrowLink"));

var _function = require("../../utils/function.utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InlineSearch = /*#__PURE__*/function (_Component) {
  _inherits(InlineSearch, _Component);

  var _super = _createSuper(InlineSearch);

  function InlineSearch() {
    var _this;

    _classCallCheck(this, InlineSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      searching: false,
      query: ''
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleSearchBar", function () {
      _this.setState({
        searching: !_this.state.searching,
        query: ''
      });

      if (_this.state.searching) {
        setTimeout(_this._focusInput, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_focusInput", function () {
      return _this.inputRef && _this.inputRef.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "_closeSearchBar", function () {
      return _this.setState({
        searching: false,
        query: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_setRef", function (ref) {
      return _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "_setContainerRef", function (ref) {
      return _this.containerRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderResults", function () {
      return _this.props.results.map(function (r) {
        return (0, _preact.h)("a", {
          href: r.link,
          className: "mtn-m-inlsearch__result"
        }, (0, _preact.h)("span", {
          className: "mtn-m-inlsearch__icon-box"
        }, (0, _preact.h)("img", {
          src: r.icon,
          className: "mtn-m-inlsearch__icon"
        })), (0, _preact.h)("div", {
          className: "mtn-m-inlsearch__result-box"
        }, (0, _preact.h)("h3", {
          className: "mtn-m-inlsearch__category"
        }, r.category), (0, _preact.h)("h4", {
          className: "mtn-m-inlsearch__title"
        }, r.title), (0, _preact.h)("p", {
          className: "mtn-m-inlsearch__description"
        }, r.description)));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_inlineSearchFunction", function (e) {
      if (_this.state.query !== e.target.value) {
        _this.setState({
          query: e.target.value
        });

        (0, _function.callFunction)(_this.props.inlineSearchFunction, 'onInlineSearch', {
          query: _this.state.query
        });
      }
    });

    return _this;
  }

  _createClass(InlineSearch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inlineSearchFunction = _this$props.inlineSearchFunction,
          buttonLabel = _this$props.buttonLabel,
          placeholder = _this$props.placeholder,
          info = _this$props.info,
          results = _this$props.results,
          allResultsLink = _this$props.allResultsLink,
          allResultsText = _this$props.allResultsText,
          allResultsLinkLabel = _this$props.allResultsLinkLabel;

      if (inlineSearchFunction) {
        return (0, _preact.h)(_HeadMenu["default"], {
          id: "mtn-header-top-search",
          onOpen: this._toggleSearchBar,
          onClose: this._closeSearchBar,
          className: "mtn-o-header__search",
          icon: this.state.searching ? _cross["default"] : _search["default"],
          onlyIconClick: this.state.searching,
          label: (0, _preact.h)("div", null, (0, _preact.h)("input", {
            value: this.state.query,
            onChange: this._inlineSearchFunction,
            onInput: this._inlineSearchFunction,
            className: "mtn-m-headmenu__input ".concat(this.state.searching ? '' : 'mtn-m-headmenu__input--hidden'),
            placeholder: placeholder,
            ref: this._setRef,
            type: "text"
          }), this.state.searching ? null : buttonLabel),
          forceOpen: this.state.searching && this.state.query && (info || results.length),
          forceLabelShow: this.state.searching,
          content: (0, _preact.h)("div", {
            className: "mtn-m-inlsearch"
          }, info ? (0, _preact.h)("div", {
            className: "mtn-m-inlsearch__info"
          }, info) : null, (0, _preact.h)("div", {
            className: "mtn-m-inlsearch__results"
          }, this._renderResults(), allResultsText || allResultsLink ? (0, _preact.h)("div", {
            className: "mtn-m-inlsearch__footer"
          }, allResultsText && (0, _preact.h)("p", {
            className: "mtn-m-inlsearch__footer-text"
          }, allResultsText), allResultsLink && (0, _preact.h)(_ArrowLink["default"], {
            href: allResultsLink,
            label: allResultsLinkLabel
          })) : null))
        });
      }

      return null;
    }
  }]);

  return InlineSearch;
}(_preact.Component);

InlineSearch.defaultProps = {
  buttonLabel: 'Zoeken',
  placeholder: 'Zoeken',
  info: '',
  results: [],
  allResultsText: '',
  allResultsLink: '',
  allResultsLinkLabel: 'Alle resultaten tonen'
};
var _default = InlineSearch;
exports["default"] = _default;